/**
 * SHARED
 * Cross-cutting code usable by any module. Must NOT import from any module.
 *
 * moduleCatalog :: the live list of customer-facing modules, used by the support
 * ticket form's "Area" dropdown so it stays in sync as modules are added.
 *
 * /shared can't import modules (boundary rule), so the composition root (App.jsx)
 * injects the list here at startup via setModuleCatalog() — it collects every
 * module index.js that exports a `moduleMeta { key, label }`. Add a module that
 * exports moduleMeta and it appears automatically; nothing here needs editing.
 */

let _modules = []; // [{ key, label }]

export function setModuleCatalog(list) {
  _modules = (Array.isArray(list) ? list : []).filter((m) => m && m.label);
}

export function getModuleCatalog() {
  return _modules;
}

// Non-module "Admin" areas always offered on the ticket form. Values are the
// stored labels (back-compatible with existing tickets).
export const TICKET_ADMIN_AREAS = ["Billing & plan", "Account & team", "Other"];

// Grouped options for the ticket "Area" dropdown: auto "Modules" + static "Admin".
// Returns [{ label, items: [string] }] — `items` are option values/labels.
export function getTicketAreaGroups() {
  const modules = [..._modules]
    .map((m) => m.label)
    .sort((a, b) => a.localeCompare(b));
  const groups = [];
  if (modules.length) groups.push({ label: "Modules", items: modules });
  groups.push({ label: "Admin", items: TICKET_ADMIN_AREAS });
  return groups;
}
